import { ILoadOperatingAreasFilters } from './interfaces/ILoadOperatingAreasFilters';

import { PaginationResponseDTO } from './dtos/PaginationResponseDTO';
import {
  OperatingAreaResponseDTO,
  TOperatingAreaStatus,
} from './dtos/OperatingAreaResponseDTO';
import { OperatingAreaRequestDTO } from './dtos/OperatingAreaRequestDTO';

import { setupApi } from '.';

export async function loadOperatingAreas(
  filters = {} as ILoadOperatingAreasFilters,
  ctx = undefined
): Promise<PaginationResponseDTO<OperatingAreaResponseDTO[]>> {
  const response = await setupApi(ctx).get<
    PaginationResponseDTO<OperatingAreaResponseDTO[]>
  >('/operating-area', { params: filters });

  return response.data;
}

export async function createOperatingArea(
  data: OperatingAreaRequestDTO,
  ctx = undefined
): Promise<OperatingAreaResponseDTO> {
  const response = await setupApi(ctx).post<OperatingAreaResponseDTO>(
    '/operating-area',
    { ...data, status: 'active' }
  );

  return response.data;
}

export async function updateOperatingArea(
  id: string,
  data: OperatingAreaRequestDTO,
  ctx = undefined
): Promise<OperatingAreaResponseDTO> {
  const response = await setupApi(ctx).put<OperatingAreaResponseDTO>(
    `/operating-area/${id}`,
    { ...data }
  );

  return response.data;
}

export async function updateOperatingAreaStatus(
  id: string,
  status: TOperatingAreaStatus,
  ctx = undefined
): Promise<OperatingAreaResponseDTO> {
  const response = await setupApi(ctx).patch<OperatingAreaResponseDTO>(
    `/operating-area/${id}/status`,
    { status }
  );

  return response.data;
}
